import { CommonKeys } from "../../common/enums";
import { BERICHT_BILD_TYPE, BERICHT_TEXT_TYPE, BERICHTE_TYPE, FORMULAR_GROUP_BERICHTE_TYPE } from "../../common/formular-group-types";

const FormularGroupBerichteSchema = {
    $id: "FormularGroupBerichteSchema",
    title: "FormularGroupBerichte Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_BERICHTE_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
        [CommonKeys.ShowLegend]: { type: "boolean" },
        Berichte: { $ref: "FormularGroupBerichteBerichteSchema" }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, "Berichte"]
}

const FormularGroupBerichteBerichteSchema = {
    $id: "FormularGroupBerichteBerichteSchema",
    title: "FormularGroupBerichteBerichte Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: BERICHTE_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: {
                anyOf: [
                    { $ref: "FormularGroupBerichteBerichtTextSchema" },
                    { $ref: "FormularGroupBerichteBerichtBildSchema" }
                ]
            }
        }
    }
}

const FormularGroupBerichteBerichtTextSchema = {
    $id: "FormularGroupBerichteBerichtTextSchema",
    title: "FormularGroupBerichteBerichtText Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: BERICHT_TEXT_TYPE },
        [CommonKeys.Value]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true }
    },
    required: [CommonKeys.Type, CommonKeys.Value, CommonKeys.Label]
}

const FormularGroupBerichteBerichtBildSchema = {
    $id: "FormularGroupBerichteBerichtBildSchema",
    title: "FormularGroupBerichteBerichtBild Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: BERICHT_BILD_TYPE },
        [CommonKeys.Value]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        ImageID: { type: "string" },
        Beschreibung: { type: "string" },
    },
    required: [CommonKeys.Type, CommonKeys.Value, CommonKeys.Label, "ImageID", "Beschreibung"]
}

export const FORMULAR_GROUP_BERICHTE_SCHEMAS = [
    FormularGroupBerichteSchema,
    FormularGroupBerichteBerichteSchema,
    FormularGroupBerichteBerichtBildSchema,
    FormularGroupBerichteBerichtTextSchema
]